<ng-container *ngTemplateOutlet="timeLoad?.load?.reserved >= timeLoad?.load?.present ? Present : Booked"></ng-container>
<ng-container *ngTemplateOutlet="timeLoad?.load?.reserved >= timeLoad?.load?.present ? Booked : Present"></ng-container>
@if (timeLoad?.load?.available < timeLoad?.load?.maxAvailable) {
  <ng-container *ngTemplateOutlet="Slots"></ng-container>
}
<ng-container></ng-container>

<ng-template #Present>
  <div
    [ngStyle]="{
      width: timeLoad?.load?.maxAvailable | calculateBarWidth: timeLoad?.load?.present,
      'background-color':
        timeLoad
        | calculateBackgroundColor
          : (isHovered ? presentFillHover : presentFill)
          : (isHovered ? presentFillHover : presentFill)
          : (isHovered ? presentFillHover : presentFill)
          : (isHovered ? presentFillHover : presentFill),
    }"
    class="spa-report-bar-capacity-present"
  ></div>
</ng-template>
<ng-template #Booked
  ><div
    [ngStyle]="{
      width: timeLoad?.load?.maxAvailable | calculateBarWidth: timeLoad?.load?.reserved,
      'background-color':
        timeLoad
        | calculateBackgroundColor
          : (isHovered ? pastHover : bookedFill)
          : (isHovered ? manyAvailableHover : bookedFill)
          : (isHovered ? someAvailableHover : bookedFill)
          : (isHovered ? lessAvailableHover : bookedFill),
    }"
    class="spa-report-bar-capacity-booked"
  ></div
></ng-template>
<ng-template #Slots
  ><div
    [ngStyle]="{
      width: timeLoad?.load?.maxAvailable | calculateBarWidth: timeLoad?.load?.maxAvailable - timeLoad?.load?.available,
      '--bar-color': isHovered ? slotsFillHover : slotsFill,
    }"
    class="spa-report-bar-capacity-slots"
  ></div
></ng-template>
